export default __webpack_public_path__ + "static/media/LIQUID.c5313d1e.png";